import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "features/store/Store";
import moment from "moment";

interface FilterIds {
    productId: any;
    BrandId: any;
    ModelId: any;
    CityId: any;
    RiderId: any;
    PromoCode: any;
    FromDate: any;
    ToDate: any;
    productName: string;
    BrandName: string;
    ModalName: string;
    CityName: string;
    PromoCodeName: string;
    RiderName: string;
}

interface DashboardFilterState {
    all: {
        [tileKey: number]: FilterIds;
    };
    today: {
        [tileKey: number]: FilterIds;
    };
}

interface payloadParams {
    entryKey?: any;
    tileKey: any;
    field: any
    fieldValue: any;
}

let today = moment().format("L");
let priorDate = moment().subtract(30, 'days').format("L");

const filerParams: FilterIds = {
    CityName: "",
    RiderName: '',
    PromoCodeName: '',
    productName: '',
    ModalName: '',
    BrandName: '',
    CityId: null,
    RiderId: null,
    productId: null,
    BrandId: null,
    ModelId: null,
    PromoCode: '',
    FromDate: priorDate,
    ToDate: null,
}

const todayFilerParams: FilterIds = {
    CityName: "",
    RiderName: '',
    PromoCodeName: '',
    productName: '',
    ModalName: '',
    BrandName: '',
    CityId: null,
    RiderId: null,
    productId: null,
    BrandId: null,
    ModelId: null,
    PromoCode: '',
    FromDate: today,
    ToDate: today,
}

interface PayloadParams {
    sectionKey: 'all' | 'today';
    tileKey: number;
    field: any;
    fieldValue: any;
}

interface ResetTilePayload {
    sectionKey?: 'all' | 'today';
    tileKey: number;
}

interface ResetAllTilesPayload {
    sections?: ('all' | 'today')[];
}

const initialState: DashboardFilterState = {
    all: {
        1: { ...filerParams },
        2: { ...filerParams },
        3: { ...filerParams },
        4: { ...filerParams },
        5: { ...filerParams },
        6: { ...filerParams },
        7: { ...filerParams },
        8: { ...filerParams },
        9: { ...filerParams },
    },
    today: {
        1: { ...todayFilerParams },
        2: { ...todayFilerParams },
        3: { ...todayFilerParams },
        4: { ...todayFilerParams },
        5: { ...todayFilerParams },
        6: { ...todayFilerParams },
        7: { ...todayFilerParams },
        8: { ...todayFilerParams },
        9: { ...todayFilerParams },
    },
};


const DashboardFilter = createSlice({
    initialState,
    name: "DashboardFilter",
    reducers: {
        updateDashboardFilter: (state, action: PayloadAction<PayloadParams>) => {
            const { sectionKey = 'all', tileKey, field, fieldValue } = action.payload;
            if (sectionKey === 'all' || sectionKey === 'today') {
                if (state[sectionKey] && state[sectionKey][tileKey] !== undefined) {
                    state[sectionKey][tileKey] = {
                        ...state[sectionKey][tileKey],
                        [field]: fieldValue,
                    };
                    localStorage.setItem("DashboardFilter_v1", JSON.stringify(state));
                }
            }
        },

        resetTile_v1: (state, action: PayloadAction<ResetTilePayload>) => {
            const { sectionKey = 'all', tileKey } = action.payload;
            if (state[sectionKey] && state[sectionKey][tileKey] !== undefined) {
                state[sectionKey][tileKey] =
                    sectionKey === 'today' ? { ...todayFilerParams } : { ...filerParams };
                localStorage.setItem("DashboardFilter_v1", JSON.stringify(state));
            }
        },

        resetAllTiles_v1: (state, action: PayloadAction<ResetAllTilesPayload>) => {
            const { sections = ['all', 'today'] } = action.payload;
            sections.forEach(section => {
                if (state[section]) {
                    Object.keys(state[section]).forEach(tileKey => {
                        state[section][Number(tileKey)] =
                            section === 'today' ? { ...todayFilerParams } : { ...filerParams };
                    });
                }
            });
            localStorage.setItem("DashboardFilter_v1", JSON.stringify(state));
        },

        setFilterToAll_v1: (state, action: PayloadAction<any>) => {
            const { sectionKey = 'all', tileKey, field, fieldValue } = action.payload;
            if (sectionKey === 'all' || sectionKey === 'today') {
                if (state[sectionKey] && state[sectionKey][tileKey] !== undefined) {
                    const defaultFromDate =
                        sectionKey === 'today' ? todayFilerParams.FromDate : filerParams.FromDate;

                    state[sectionKey][tileKey] = {
                        ...state[sectionKey][tileKey],
                        FromDate: fieldValue ? fieldValue : defaultFromDate,
                    };

                    localStorage.setItem("DashboardFilter_v1", JSON.stringify(state));
                }
            }
        },

    }
});

export const {
    updateDashboardFilter, resetTile_v1, resetAllTiles_v1,
    setFilterToAll_v1
} = DashboardFilter.actions;

export const FilterDashboardValue = (state: RootState) => state.DashboardFilterReducers;

export default DashboardFilter.reducer;
